import { render, staticRenderFns } from "./ProgramPestsTable.vue?vue&type=template&id=0afb9255&"
import script from "./ProgramPestsTable.vue?vue&type=script&lang=js&"
export * from "./ProgramPestsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports